<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <div class="text-right mb-3"></div>
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                            size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields"
                        :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light"
                        class="sa-b-table">
                        <template #cell(index)="row">
                            <span> {{ row.index + 1 }} </span>
                        </template>
                        <template #cell(descrizioneMetodoPagamento)="row">
                            <span style="font-weight: 600">{{ row.item.descrizioneMetodoPagamento }}</span>
                        </template>
                        <template #cell(fineMeseMetodoPagamento)="row">
                            <span style="font-weight: 600">{{ row.item.fineMeseMetodoPagamento ? "SI" : "NO" }}</span>
                        </template>
                        <template #cell(frazionamenti)="row">
                            <span style="font-weight: 600">{{ row.item.frazionamenti.length }}</span>
                        </template>
                        <template v-slot:cell(actions)="row">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Modifica" variant="outline-success"
                                    @click="onClickEditSoggetti(row.item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Cancella" variant="outline-danger"
                                    @click="onClickDeleteSoggetti(row.item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                            size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/contabilitasoggettotipi",
            showModalLoading: false,
            listKey: 0,
            filtroConfigurazioneContabilitaSoggetti: {},
            items: [],
            fields: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 1rem",
                },
                {
                    label: "Descrizione Tipo",
                    key: "descrizioneTipo",
                    thStyle: "width: 5rem",
                },
                {
                    label: "Codice Tipo Soggetto",
                    key: "codiceTipoSoggetto",
                    thStyle: "width: 5rem",
                },
                {
                    label: "Codice Soggetto Collegato",
                    key: "codiceSoggettoCollegato",
                    thStyle: "width: 5rem",
                },
                {
                    label: "Codice Azienda",
                    key: "codiceAzienda",
                    thStyle: "width: 1rem",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    mounted() { },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {


        loadData() {
            let me = this;
            me.openShowModalLoading();
            me.$emit("beforeLoadData");
            if (sessionStorage["filtroConfigurazioneContabilitaSoggetti"]) {
                me.filtroConfigurazioneContabilitaSoggetti = JSON.parse(sessionStorage["filtroConfigurazioneContabilitaSoggetti"]);
            }
            me.filtroConfigurazioneContabilitaSoggetti.page = me.currentPage;
            me.filtroConfigurazioneContabilitaSoggetti.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroConfigurazioneContabilitaSoggetti, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.closeShowModalLoading();
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            console.error("Errore durante il caricamento dei dati:", error);
            me.items = [];
            me.rows = 0;
            me.closeShowModalLoading();
            me.$emit("afterLoadData");
        },
        onClickEditSoggetti(item) {
            this.$emit("editSoggettoTipo", item);
        },
        onClickDeleteSoggetti(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare ?", {
                    title: "Eliminazione Soggetti",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteSoggetti(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteSoggetti(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteSoggettiSuccess, me.deleteSoggettiError);
        },
        deleteSoggettiSuccess(response) {
            let me = this;
            response;
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.loadData();
        },
        deleteSoggettiError() {
            let me = this;
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>

<style scoped>
.sa-badge-action {
    text-align: end !important;
}
</style>
